import { render, staticRenderFns } from "./solutions.vue?vue&type=template&id=33f24f6a&scoped=true"
import script from "./solutions.vue?vue&type=script&lang=js"
export * from "./solutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f24f6a",
  null
  
)

export default component.exports